import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOneclickicon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7168 14.5V13.1111C11.7168 11.577 12.9604 10.3333 14.4946 10.3333C16.0287 10.3333 17.2724 11.577 17.2724 13.1111V14.5M27 14.5C27 21.4036 21.4036 27 14.5 27C11.6717 27 2.001 27 2.001 27C2.001 27 4.16654 21.8001 3.29988 20.0567C2.46785 18.3828 2 16.4961 2 14.5C2 7.59645 7.59643 2 14.5 2C21.4036 2 27 7.59645 27 14.5ZM12.4112 18.6667H16.5779C17.225 18.6667 17.5486 18.6667 17.8039 18.561C18.1442 18.42 18.4146 18.1496 18.5556 17.8093C18.6612 17.554 18.6612 17.2304 18.6612 16.5833C18.6612 15.9363 18.6612 15.6126 18.5556 15.3574C18.4146 15.0171 18.1442 14.7467 17.8039 14.6057C17.5486 14.5 17.225 14.5 16.5779 14.5H12.4112C11.7642 14.5 11.4405 14.5 11.1853 14.6057C10.845 14.7467 10.5746 15.0171 10.4336 15.3574C10.3279 15.6126 10.3279 15.9363 10.3279 16.5833C10.3279 17.2304 10.3279 17.554 10.4336 17.8093C10.5746 18.1496 10.845 18.42 11.1853 18.561C11.4405 18.6667 11.7642 18.6667 12.4112 18.6667Z",
		stroke: "black",
		strokeWidth: 2.77778,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgOneclickicon;
